module.exports = __webpack_public_path__ + "static/media/RiverbendMaltbillheadstylelogo2018.8fa286bb.webp";